export default {"src":"/_next/static/media/coinbase.b792a766.svg","height":44,"width":137,"blurWidth":0,"blurHeight":0};